import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Loading from '../../features/shared/components/Loading'
import PageErrorBoundary from './PageErrorBoundary'

/**
 * The page card for table routes, inside AppShellLayout, on the near-white page
 * canvas the table workspace sits on.
 *
 * Complete table workspaces compose their own titlebars inside the host so the
 * same chrome boundary works for route-filling and embedded tables.
 */
export default function TableLayout() {
  return (
    <div className="app-page-card flex min-w-0 flex-1 overflow-hidden bg-[color:var(--surface-page)]">
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <PageErrorBoundary>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </PageErrorBoundary>
      </main>
    </div>
  )
}
